import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    delete: 'Delete item',
    description: 'The change will appear on your next invoice.',
    errorMessage:
      'An error has occurred. Please try again and if the problem persists, please contact us.',
    successMessage: 'Changes successfully saved!',
    title: 'Edit your item',
  },
  fr: {
    cancel: 'Annuler',
    delete: 'Supprimer l’article',
    description:
      'La modification apparaîtra sur votre prochaine facture créée.',
    errorMessage:
      'Une erreur est survenue. Réessayez et si le problème persiste, contactez-nous.',
    successMessage: 'Modifications enregistrées avec succès !',
    title: 'Modifier votre article',
  },
} as const);
